import React, { ReactElement, useCallback, useRef } from "react";

import classNames from "classnames";

import { chatDialogCSS, resizeHandleCSS } from "./ChatDialog.styles";

import { IconResizeCorner } from "../icons/IconResizeCorner";

import { ChatDialogHeader } from "../ChatDialogHeader";
import { ChatDialogProps } from "./ChatDialog.types";

export const ChatDialog = ({
  children,
  className,
  agentName,
  isBeta,
  onFullScreenClick,
  onClose,
  ...rest
}: ChatDialogProps): ReactElement => {
  const resizeRef = useRef<HTMLDivElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);

  const handleResizeMouseDown = useCallback(
    (e: React.MouseEvent) => {
      const startX = e.clientX;
      const startY = e.clientY;
      const startWidth = modalRef?.current?.offsetWidth || 0;
      const startHeight = modalRef?.current?.offsetHeight || 0;

      const handleMouseMove = (moveEvent: MouseEvent): void => {
        const newWidth = startWidth + moveEvent.clientX - startX;
        const newHeight = startHeight + moveEvent.clientY - startY;
        modalRef.current?.setAttribute(
          "style",
          `width: ${newWidth}px; height: ${newHeight}px; bottom: auto, right: auto; top: ${
            modalRef?.current?.getBoundingClientRect().top
          }px; left: ${modalRef?.current?.getBoundingClientRect().left}px`
        );
      };

      const handleMouseUp = (): void => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    },
    [modalRef]
  );

  return (
    <div
      className={classNames(chatDialogCSS, className)}
      ref={modalRef}
      data-testid="chat-dialog"
      {...rest}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          margin: 10,
          border: "1px solid #e1e2e5",
          boxShadow: "0 0 18px 0 rgba(18, 19, 21, 0.18)",
          borderRadius: 12,
          overflow: "hidden",
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        <ChatDialogHeader
          modalRef={modalRef}
          agentName={agentName}
          isBeta={isBeta}
          onFullScreenClick={onFullScreenClick}
          onClose={onClose}
        />
        {children}
        <div
          ref={resizeRef}
          className={resizeHandleCSS}
          onMouseDown={handleResizeMouseDown}
          data-testid="chat-dialog-resize-handle"
        >
          <IconResizeCorner style={{ width: 13, height: 13 }} />
        </div>
      </div>
    </div>
  );
};

ChatDialog.displayName = "ChatDialog";
